export default "__VITE_ASSET__CotaFhYh__";